const CAROUSEL_ITEMS = [
  {
    tag: '爆',
    title: '某顶流艺人私生活大起底：圈内人匿名爆料细节惊人',
    excerpt: '多位圈内人士联合爆料，涉及多名一线艺人，细节令人瞠目。本专题持续追踪事件进展，汇总多方信源交叉验证。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20red%20and%20black%20abstract%20background%20with%20dynamic%20light%20streaks%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20vibe%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20no%20faces%20or%20text&width=800&height=500&seq=carousel-card-01&orientation=landscape',
    stats: { views: '128万', comments: '3.6万' },
  },
  {
    tag: '热',
    title: '直播带货界又出大事！头部主播涉嫌虚假宣传被实名举报',
    excerpt: '消费者协会已介入调查，涉事账号粉丝超千万。本专题整理完整事件时间线与各方回应，还原真相。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20golden%20amber%20and%20deep%20crimson%20abstract%20composition%2C%20streaming%20studio%20vibe%20without%20people%2C%20dramatic%20lighting%20effects%2C%20modern%20broadcast%20aesthetic%2C%20bold%20contrast%20and%20energy&width=800&height=500&seq=carousel-card-02&orientation=landscape',
    stats: { views: '96万', comments: '2.8万' },
  },
  {
    tag: '新',
    title: '综艺节目录制现场突发冲突，节目组紧急叫停引热议',
    excerpt: '现场观众爆料称冲突双方均为知名艺人，节目组至今未发声明。独家整理现场多名目击者还原事发经过。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20dark%20background%20with%20vibrant%20color%20accents%2C%20entertainment%20show%20vibe%2C%20no%20people%2C%20cinematic%20mood&width=800&height=500&seq=carousel-card-03&orientation=landscape',
    stats: { views: '85万', comments: '2.1万' },
  },
  {
    tag: '深',
    title: '深度调查：娱乐圈资本游戏背后的灰色利益链条',
    excerpt: '历时三个月调查，揭示多家娱乐公司与资本方之间不为人知的交易内幕。本专题为年度重磅深度报道。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20atmosphere%20with%20golden%20accent%20lights%2C%20corporate%20investigation%20vibe%2C%20abstract%20financial%20and%20entertainment%20elements%2C%20dramatic%20shadows%2C%20no%20text%20or%20faces&width=800&height=500&seq=carousel-card-04&orientation=landscape',
    stats: { views: '72万', comments: '1.9万' },
  },
  {
    tag: '追',
    title: '年度最大反转：被骂三年的艺人原来一直在默默做公益',
    excerpt: '网友自发整理大量证据为其正名，事件持续发酵引发广泛讨论。本专题追踪舆论反转全过程，见证网络正义。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20hopeful%20abstract%20composition%20with%20rising%20golden%20light%2C%20from%20darkness%20to%20brightness%2C%20redemption%20theme%2C%20soft%20dramatic%20lighting%2C%20inspirational%20cinematic%20aesthetic&width=800&height=500&seq=carousel-card-05&orientation=landscape',
    stats: { views: '156万', comments: '5.2万' },
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周最受关注的五大专题，吃瓜必看
          </p>
        </div>

        <div className="space-y-6">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <article
              key={idx}
              className="flex flex-col md:flex-row gap-5 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/60"
            >
              <div className="w-full md:w-[340px] lg:w-[420px] shrink-0">
                <div className="relative w-full aspect-[16/10] rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>{item.stats.views}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-chat-3-line mr-1"></i>{item.stats.comments}
                  </span>
                </div>
                <h3 className="font-semibold text-lg md:text-xl text-foreground-900 mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.excerpt}
                </p>
                <a
                  href="#ranking"
                  className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  查看完整专题 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}